var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerRight1"}},[_vm._m(0),_c('div',{staticClass:"bg-r3"},[_c('div',{staticClass:"d-flex jc-center body-box"},[_c('dv-scroll-board',{staticClass:"dv-scr-board",attrs:{"config":_vm.config}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_bg"},[_c('p',[_vm._v("区块链节点")])])
}]

export { render, staticRenderFns }